import { Stack, Typography } from '@mui/material';

function AuthHeader({ mode }) {
  const title =
    mode === 'signup' ? 'Sign up' : mode === 'reset' ? 'Reset password' : 'Sign in';
  const description =
    mode === 'signup'
      ? 'Verify your email first, then finish creating your account.'
      : mode === 'reset'
        ? 'Request a one-time code, then choose a new password for your account.'
        : 'Enter your email and password to sign in.';

  return (
    <Stack spacing={1}>
      <Typography className="auth-brand" variant="h6">
        ta2shera.com
      </Typography>
      <Typography variant="h4">{title}</Typography>
      <Typography color="text.secondary" variant="body2">
        {description}
      </Typography>
    </Stack>
  );
}

export default AuthHeader;
